import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBookmarkSimple = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 15, viewBox: "0 0 12 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.5 14.25L6 11.4375L1.5 14.25V1.875C1.5 1.72582 1.55926 1.58274 1.66475 1.47725C1.77024 1.37176 1.91332 1.3125 2.0625 1.3125H9.9375C10.0867 1.3125 10.2298 1.37176 10.3352 1.47725C10.4407 1.58274 10.5 1.72582 10.5 1.875V14.25Z", stroke: "#525A68", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgBookmarkSimple);
const Memo = memo(ForwardRef);
export default Memo;
